module.exports = __webpack_public_path__ + "18c39901ff27de06177900ec8f202a14.svg";